import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { LanguageConstants } from '../utils/constants/language.constants';
@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  constructor(private translocoService: TranslocoService) {}

  loadScopedTranslation(scope: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const lang = this.translocoService.getActiveLang();

      if (!scope || scope === '' || scope === 'root') {
        // Load root translations
        this.translocoService.load(lang).subscribe({
          next: () => {
            resolve();
          },
          error: (err) => {
            reject(err);
          },
        });
      } else {
        // Load scoped translations
        this.translocoService.load(`${scope}/${lang}`).subscribe({
          next: () => {
            resolve();
          },
          error: (err) => {
            reject(err);
          },
        });
      }
    });
  }
  //Translate a given key, allowing optional parameters for dynamic values or language specification. Use this method when you need to translate keys directly in components or services.

  translate(key: string, scope?: string, params?: any): string {
    const translatedValue = this.translocoService.translate(key, params, scope);
    return translatedValue;
  }
  selectTranslate(key: string, params?: any, scope?: string) {
    return this.translocoService.selectTranslate(key, params, scope);
  }

  findLocale() {
    const currentLocale = this.translocoService.getActiveLang();
    if (currentLocale) {
      return currentLocale;
    } else {
      console.warn('No active language found, defaulting to "en"');
      return LanguageConstants.DEFAULT_LANGUAGE_CODE; // Default to English if no active language is set
    }
  }
}
